import React from 'react';
import { useFeatureToggle } from '@hotelplan/libs.feature-toggle';
import { FeatureList } from 'config/featureList';
import { FdrPageComponentsFragment } from 'schemas/fragment/page-components/fdr-page-components.generated';
import FdrCustomBenefitsPageComponent from './benefits/fdr-custom-benefits-page-component';
import { FdrPageComponents } from './index';

const NEW_DESIGN_VARIANT = 'new-design';

interface IFdrGeoStaticPageComponentsProps {
  components: FdrPageComponentsFragment['components'];
}

const FdrPageComponentsWithCustomBenefits: React.FC<IFdrGeoStaticPageComponentsProps> =
  ({ components }) => {
    const { getVariant } = useFeatureToggle();
    const variant = getVariant(FeatureList.stepsHowWeWork);

    const indexOfBenefitsComponent = components?.findIndex(
      component => component.__typename === 'FdrBenefitsComponent'
    );

    if (
      typeof indexOfBenefitsComponent === 'undefined' ||
      indexOfBenefitsComponent === -1 ||
      !variant?.enabled ||
      variant.name !== NEW_DESIGN_VARIANT
    ) {
      return <FdrPageComponents components={components} />;
    }

    const beforeComponents = components.slice(0, indexOfBenefitsComponent);
    const afterComponents = components.slice(indexOfBenefitsComponent + 1);
    const benefitsComponent = components[indexOfBenefitsComponent] as Extract<
      FdrPageComponentsFragment['components'][number],
      { __typename: 'FdrBenefitsComponent' }
    >;

    return (
      <>
        <FdrPageComponents
          components={beforeComponents}
          key="page-components-before-benefits"
        />
        <FdrCustomBenefitsPageComponent component={benefitsComponent} />
        <FdrPageComponents
          components={afterComponents}
          key="page-components-after-benefits"
        />
      </>
    );
  };

export default FdrPageComponentsWithCustomBenefits;
